<template>
    <div class="list-info">
        <!-- <div  class="study-radio">
            <el-radio-group v-model="studyRadio" size="mini">
                <el-radio-button v-for="item  in radioList" :key="item.label" :label="item.label" >{{ item.value }}</el-radio-button>
            </el-radio-group>
        </div> -->
        <ul v-if="studyListInfo&&studyListInfo.length!=0">
            <li class="info" v-for="(item,index) in studyListInfo" :key="index">
                <a>
                    <div class="info-txt"> 
                        <div class="txt-tit">{{item.tit}}</div>
                        <div class="sublevel-txt">
                            <span v-for="(sublevel,num) in item.sublevel" :key="num">{{sublevel}}</span>
                        </div> 
                    </div>
                </a>
            </li>
        </ul>
        <div v-else class="no-data">敬请期待……</div>
        <div v-if="studyListInfo&&studyListInfo.length>=6" class="look-more" @click="toPage(studyListInfo,'more')">查看更多</div>
    </div>
</template>

<script>

import { bookList } from '../../../../io/api';
export default {
    components: {},
    data() {
        return {
            studyListInfo:[ ],
            studyRadio:'1',
            radioList:[
                {
                    label:'1',
                    value:'方剂医案',
                },{
                    label:'2',
                    value:'中药课堂',
                },{
                    label:'3',
                    value:'常用中成药',
                },
            ],
        }
    },
    watch: {},
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            let params={
                page: 1,
                limit: 6,
                keyWord:'',
                faceName:'',
                faceValue:'',
            }; 
            bookList(params).then(res => {
                let {code,data,msg}=res.data;
                if(code==0){
                    this.studyListInfo= [ ]; 
                }else{
                    this.$message.error(msg||'请求失败～');
                }
            })

             
        },

        toPage(item,type){    
            let url= this.$router.resolve({
                path:'',
                query:{ 
                    changeflag: 3
                }
            }) 
            this.$windowOpen({ url:url.href,isLogin:true} )
        },
        
    }
}
</script>
<style lang='less' scoped>
    @import url('./study.less');
    
</style>